import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Draggable } from '@hello-pangea/dnd'
import cx from 'helpers/cx'

import { CoverPageIcon } from '@pleio/icons/cover-page'
import { MoveVerticalIcon } from '@pleio/icons/move-vertical'

import IconButton from 'js/components/IconButton'

import styles from './Article.module.css'

type ArticleProps = {
    id: string
    index: number
}

const Article = ({ id, index }: ArticleProps) => {
    const { t } = useTranslation()

    const { control } = useFormContext()

    const watchArticles = useWatch({
        name: 'articles',
        control,
    })

    const title = watchArticles?.[index]?.title ?? ''

    const buttonProps = {
        type: 'button',
        size: 'large',
        variant: 'secondary',
        bgOffset: 'sm',
        radiusStyle: 'rounded',
    } as const

    const label = `${index + 1}. ${title}`

    const featured = [0, 1, 2].includes(index)

    return (
        <Draggable draggableId={id} index={index}>
            {(provided, snapshot) => (
                <li
                    ref={provided.innerRef}
                    className={cx(
                        styles.wrapper,
                        snapshot.isDragging && styles.isDragging,
                    )}
                    {...provided.draggableProps}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            {...buttonProps}
                            as="div"
                            tooltip={t('action.move')}
                            aria-label={t('aria.move-field', {
                                label,
                            })}
                            {...(provided.dragHandleProps as any)}
                            tooltipProps={{ side: 'left' }}
                        >
                            <MoveVerticalIcon />
                        </IconButton>

                        <div className={styles.articleLabel}>{label}</div>

                        {featured && (
                            <IconButton
                                {...buttonProps}
                                as="div"
                                tooltip={t('entity-magazine.featured-on-cover')}
                                aria-label={t(
                                    'entity-magazine.featured-on-cover-aria',
                                    {
                                        label,
                                    },
                                )}
                                tooltipProps={{ side: 'right' }}
                            >
                                <CoverPageIcon />
                            </IconButton>
                        )}
                    </div>
                </li>
            )}
        </Draggable>
    )
}

export default Article
